export default "__VITE_ASSET__cfc13538__"